import Button, { ButtonProps } from '../Button'
import { ButtonVariant } from '../types'

// Wrapper around Button that gives semantic meaning
// and future proofs against any changes to base button
const SecondaryButton = (props: ButtonProps) => (
  <Button variant={ButtonVariant.Secondary} {...props} />
)

export default SecondaryButton
